import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ssrRef, useContext, useRoute, useStore } from "@nuxtjs/composition-api";
import { storeToRefs } from "pinia";

import { useAmplitude } from "@/composables";
import { useCreatorShopPostsStore } from "@/store/creator-shop-posts";
import { getProfilesStore } from "@/store/profiles"; // TODO - replace after store refactor
import { handleErrorStatusCode, handleServiceError } from "@/utils/api";
import { NOT_FOUND } from "@/utils/enums/http-codes";
import { heroImageCreatorShop } from "@/utils/services/LtkItemHeightCalculator";


export default /*#__PURE__*/_defineComponent({
  __name: 'PostFeed',
  props: {
  displayName: { type: String, required: true },
  ltkId: { type: String, required: false, default: undefined },
  isVisible: { type: Boolean, default: false },
},
  setup(__props) {

const props = __props;



const context = useContext();
const route = useRoute();
const store = useStore();
const amplitude = useAmplitude();
const creatorShopPostsStore = useCreatorShopPostsStore();
const { term, fetchState } = storeToRefs(creatorShopPostsStore);

const profileId = computed(() => getProfilesStore(store).getIdByDisplayName(props.displayName));
const isSearchingFeed = computed(() => term.value !== null && term.value !== "");
const paginate = ssrRef(false, "PostFeed paginate");
const itemHeightFunction = heroImageCreatorShop;
const postIds = computed(() => {
  const feed = (isSearchingFeed.value ? term.value : profileId.value) as string;
  const posts = creatorShopPostsStore.getFeed(feed).ids;
  return posts;
});

const fetchPosts = async () => {
  if (!props.displayName) {
    return handleServiceError({
      context,
      error: {
        status: NOT_FOUND,
        errorCode: "profile-not-found",
        developerMessage: "No display name provided",
      },
      meta: {
        url: route.value.fullPath,
        ltkId: props.ltkId,
        displayName: props.displayName,
      },
    });
  }

  if (paginate.value || postIds.value?.length === 0) {
    try {
      // When user is searching and the feed pagination is triggered, fetch posts by search term.
      if (term.value) {
        await creatorShopPostsStore.fetchBySearchTerm();
        return;
      }
      // Fetch posts
      await creatorShopPostsStore.fetch();
      return;
    } catch (error) {
      return handleServiceError({
        context,
        error: {
          status: handleErrorStatusCode(error),
          errorCode: "creator-shop-feed-error",
          developerMessage: `Error fetching creator shop feed for (${props.displayName})`,
        },
        originalError: error,
        meta: {
          url: route.value.fullPath,
          ltkId: props.ltkId,
          displayName: props.displayName,
        },
      });
    }
  }
  paginate.value = true;
};

const onPaging = async () => {
  amplitude?.sendScrollEvent("/scroll/publisher", postIds.value?.length);
  await fetchPosts();
};

onMounted(async () => {
  await fetchPosts();
});

return { __sfc: true,props, context, route, store, amplitude, creatorShopPostsStore, term, fetchState, profileId, isSearchingFeed, paginate, itemHeightFunction, postIds, fetchPosts, onPaging }
}

})